import axios from 'axios'

const API = axios.create({ baseURL: 'https://wabbis.herokuapp.com'})
// const API = axios.create({ baseURL: 'http://localhost:5000'})

API.interceptors.request.use((req) => {
    if (localStorage.getItem('profile')) {
      req.headers.Authorization = `Bearer ${JSON.parse(localStorage.getItem('profile')).token}`;
    }
  
    return req;
  });
  
export const fetchSpecies =() => API.get('/species')
export const addSpecies =( species ) => API.post('/species', species)
export const updateSpecies = (id, updatedSpecies) => API.patch(`/species/${id}`, updatedSpecies)
export const deleteSpecies =(id) => API.delete(`/species/${id}`)


export const fetchResponses =() => API.get('/responses')
export const addResponse =( response) => API.post('/responses', response)

export const signIn =(formData)=> API.post('/users/signin', formData)
export const signUp =(formData)=> API.post('/users/signup', formData)
export const fetchUsers =() => API.get('/users')